import { useState } from "react";
/**
 * useSimilarListings handles the similarListings data that are lazy loaded
 * @returns similarListings:  data returned from the API - raw data used for tracking
 * @returns similar record of similarListings  to be used in the carousel for Card MFE
 * @returns if similarListings is displayed
 * @returns if similarListings is fetched
 */
export const useSimilarListings = () => {
    const [similarListings, setSimilarListings] = useState([]);
    const [similarRecords, setSimilarRecords] = useState(undefined);
    const [isDisplayed, setIsDisplayed] = useState(false);
    const [isFetched, setIsFetched] = useState(false);
    const setSimilarListingsData = (data) => {
        setSimilarListings(data);
        setSimilarRecords(data === null || data === void 0 ? void 0 : data.filter((card) => Object.keys(card).length > 1).reduce((acc, card) => ({ ...acc, [card.id]: card }), {}));
        setIsDisplayed(!!(data === null || data === void 0 ? void 0 : data.length));
        setIsFetched(true);
    };
    return {
        similarListings,
        similarRecords,
        isDisplayed,
        isFetched,
        setSimilarListingsData,
    };
};
